<script setup lang="ts">
  import { MatejScenarios } from '@borg/types';
  import { MpCard, MpText, useMpScreen } from '@borg/ui';

  const props = defineProps<{
    scenario: MatejScenarios;
  }>();

  const { data: recommendedJobs, error } = await recommendedJobsRepository.getMany(
    props.scenario,
    false,
    false,
  );

  const { isMobile } = useMpScreen();

  const showWidget = computed(
    () => error.value === null && !!recommendedJobs.value && recommendedJobs.value.length > 0,
  );
</script>

<template>
  <MpCard
    v-if="showWidget"
    shadow
    border
    :p="isMobile ? 'md' : 'lg'"
    class="recommended-jobs-container"
  >
    <MpText as="h6">
      {{ $t('INDEX_PAGE.RECOMMENDED_JOBS_SECTION_TITLE').toUpperCase() }}
    </MpText>
    <div class="recommended-jobs-container__list">
      <JobCardRecommended
        v-for="item in recommendedJobs"
        :key="item.id"
        :item="item"
        source="job_details_recommended"
        class="recommended-jobs-container__list-item"
      />
    </div>
  </MpCard>
</template>

<style scoped lang="scss">
  .recommended-jobs-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    color: var(--mp-color-text-05);

    &__list {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: var(--mp-space-55);
      margin-bottom: 0;
    }

    &__list-item {
      &:not(:last-child) {
        padding-bottom: var(--mp-space-55);
        border-bottom: 1px solid var(--mp-color-grey-200);
        @include dark-mode {
          border-bottom: 1px solid var(--mp-color-grey-800);
        }
      }
    }
  }
</style>
